<script lang="ts">
    import type { ToolBoxViews } from "../../../scenario/test/ToolBoxViews";
    import type { ToolBoxManager } from "../toolbox/ToolBoxManager";

    export let manager: ToolBoxManager<ToolBoxViews>;
    let openToolBox = manager.getOpenToolBoxStore();

    const onClick = () => {
        if ($openToolBox === "baselayers") {
            $openToolBox = "none";
        } else {
            $openToolBox = "baselayers";
        }
    };

    const todo = () => {};
</script>

<div on:click={onClick} on:keydown={todo} class="btn btn-toolbox {$openToolBox === 'baselayers' ? 'active' : ''}">
    <svg
        class="toolbox-icon"
        viewBox="0 0 20 20"
        id="iD-icon-layers"
        xmlns="http://www.w3.org/2000/svg"
        ><path
            d="M9.5 3L3 6v1l6.5 3h1L17 7V6l-6.5-3h-1zM4.094 9.5L3 10v1l6.5 3h1l6.5-3v-1l-1.094-.5L10.5 12h-1L4.094 9.5zm0 4L3 14v1l6.5 3h1l6.5-3v-1l-1.094-.5L10.5 16h-1l-5.406-2.5z"
        /></svg
    >
</div>

<style>
    svg path {
        fill: #fff;
    }
</style>
